/* ==========================================================================
   THE SCIENCE OF GLOW — page behaviour.
   Independent IIFEs; each one no-ops if its markup is absent, so the file is
   safe to load on any page.
   ========================================================================== */

/* --- 1. scroll reveal ------------------------------------------------- */
(function () {
  'use strict';
  var els = document.querySelectorAll('.sglow__rv');
  if (!els.length) return;

  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) {
    for (var i = 0; i < els.length; i++) els[i].classList.add('is-in');
    return;
  }

  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (entry) {
      if (!entry.isIntersecting) return;
      entry.target.classList.add('is-in');
      io.unobserve(entry.target);
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });

  for (var j = 0; j < els.length; j++) io.observe(els[j]);
})();

/* --- 2. scroll-linked motion: hero drift and the pathway fill --------- */
(function () {
  'use strict';
  var frame = document.querySelector('[data-sglow-parallax]');
  var path = document.querySelector('[data-sglow-path]');
  if (!frame && !path) return;

  var steps = path ? [].slice.call(path.querySelectorAll('[data-sglow-step]')) : [];
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  if (reduce) {
    if (path) path.style.setProperty('--sglow-p', 1);
    steps.forEach(function (s) { s.classList.add('is-on'); });
    return;
  }

  var ticking = false;

  function update() {
    ticking = false;
    var vh = window.innerHeight;

    if (frame) {
      var fr = frame.getBoundingClientRect();
      if (fr.bottom > 0 && fr.top < vh) {
        var shift = Math.min(1, Math.max(0, -fr.top / fr.height + 0.15));
        frame.style.setProperty('--sglow-shift', shift.toFixed(3));
      }
    }

    if (path) {
      var pr = path.getBoundingClientRect();
      /* the fill's leading edge follows a line 62% of the way down the screen */
      var reach = vh * 0.62 - pr.top;
      var p = Math.min(1, Math.max(0, reach / pr.height));
      path.style.setProperty('--sglow-p', p.toFixed(4));
      steps.forEach(function (step) {
        step.classList.toggle('is-on', step.offsetTop <= reach);
      });
    }
  }

  function onScroll() {
    if (ticking) return;
    ticking = true;
    window.requestAnimationFrame(update);
  }

  window.addEventListener('scroll', onScroll, { passive: true });
  window.addEventListener('resize', onScroll);
  update();
})();

/* --- 3. Glow Protocol tabs -------------------------------------------- */
(function () {
  'use strict';
  var root = document.querySelector('[data-sglow-protocol]');
  if (!root) return;

  var tabs = [].slice.call(root.querySelectorAll('[data-sglow-tab]'));
  var panels = [].slice.call(root.querySelectorAll('[data-sglow-panel]'));
  if (!tabs.length || tabs.length !== panels.length) return;

  function select(index, focus) {
    tabs.forEach(function (tab, i) {
      var on = i === index;
      tab.setAttribute('aria-selected', on ? 'true' : 'false');
      tab.tabIndex = on ? 0 : -1;
      panels[i].classList.toggle('is-active', on);
    });
    if (focus) tabs[index].focus();
  }

  tabs.forEach(function (tab, i) {
    tab.addEventListener('click', function () { select(i, false); });
    tab.addEventListener('keydown', function (e) {
      var next = null;
      if (e.key === 'ArrowRight') next = (i + 1) % tabs.length;
      else if (e.key === 'ArrowLeft') next = (i - 1 + tabs.length) % tabs.length;
      else if (e.key === 'Home') next = 0;
      else if (e.key === 'End') next = tabs.length - 1;
      if (next === null) return;
      e.preventDefault();
      select(next, true);
    });
  });

  /* "See the ritual" links in the find-your-active section open their tab;
     the link's own #anchor then scrolls to the tabs */
  [].forEach.call(document.querySelectorAll('[data-sglow-open]'), function (link) {
    link.addEventListener('click', function () {
      var n = parseInt(link.getAttribute('data-sglow-open'), 10) - 1;
      if (n >= 0 && n < tabs.length) select(n, false);
    });
  });

  root.classList.add('is-ready');
})();

/* --- 4. packshot tilt (mouse only) ------------------------------------ */
(function () {
  'use strict';
  var stages = document.querySelectorAll('[data-sglow-tilt]');
  if (!stages.length) return;
  if (!window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  [].forEach.call(stages, function (stage) {
    stage.addEventListener('pointermove', function (e) {
      var r = stage.getBoundingClientRect();
      var x = (e.clientX - r.left) / r.width - 0.5;
      var y = (e.clientY - r.top) / r.height - 0.5;
      stage.style.setProperty('--sglow-ry', (x * 7).toFixed(2) + 'deg');
      stage.style.setProperty('--sglow-rx', (y * -7).toFixed(2) + 'deg');
    });
    stage.addEventListener('pointerleave', function () {
      stage.style.setProperty('--sglow-ry', '0deg');
      stage.style.setProperty('--sglow-rx', '0deg');
    });
  });
})();
